import { dashboardApiClient } from "./DashboardApiClient.js";

const RESOURCE_TYPES = new Set(["application", "project_template", "activation", "asset"]);

export default class PublishingCategoriesService {
  constructor(client = dashboardApiClient) {
    this.client = client;
  }

  async getCategories(resourceType) {
    if (!RESOURCE_TYPES.has(resourceType)) {
      throw new Error(`Unsupported publishing category resource type: ${resourceType}`);
    }

    return this.client.getJson(`public/publishing-categories?resource_type=${encodeURIComponent(resourceType)}`, {}, false);
  }
}
